import { Dialog } from "@xp-design/mobile";
import { useImperativeHandle, useState } from "react";
import style from "./index.module.less";
import "./index.less";
import React from "react";
interface Props {
  content: string; // 显示的 文字内用
  sureBtnStr: string; // 确认字样
  title: string; // 标题
  onCallback?: () => void; // 确认按钮回调事件
  onCloseCallback?: () => void; // 取消按钮回调事件
  isNeedCloseBtn?: boolean; //是否显示取消按钮
}
const FontSetBox = React.forwardRef((props: Props, ref) => {
  const {
    title,
    content,
    onCallback,
    sureBtnStr,
    onCloseCallback,
    isNeedCloseBtn = false,
  } = props;
  const [visible, setVisible] = useState(false);
  const onClose = () => {
    if(onCloseCallback) onCloseCallback();
    setVisible(false);
  };
  const onOpen = () => setVisible(true);
  const onSureClick = () => {
    if(onCallback) onCallback();
    onClose();
  };
  useImperativeHandle(ref, () => ({
    onClose,
    onOpen,
  }));
  return (
    <Dialog
      visible={visible}
      onClose={onClose}
      getContainer={null}
      title={title}
      closeOnMaskClick={false}
      bodyClassName="recordCustomDialog"
      content={
        <div className={style["dialogBox"]}>
          <div className={style["testBox"]}>{content}</div>
          <div className={style["btnBox"]}>
            {isNeedCloseBtn && (
              <div className={style["iknow-btn-gray"]} onClick={onClose}>
                取消
              </div>
            )}
            <div className={style["iknow-btn-green"]} onClick={onSureClick}>
              {sureBtnStr}
            </div>
          </div>
        </div>
      }
    />
  );
});

export default FontSetBox;
